import React, { Component, createContext } from "react";
import { db } from "../services/firebase";

export const SubmissionsContext = createContext({ submissions: {} });

class SubmissionsProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submissions: {},
        };
    }
    componentDidMount() {
        db.collection("fileSubmissions").onSnapshot((querySnapshot) => {
            querySnapshot.docChanges().forEach((change) => {
                let doc = change.doc;
                let data = doc.data();
                this.setState((state) => {
                    state.submissions[doc.id] = data;
                    return state;
                });
            });
        });
    }

    render() {
        return (
            <SubmissionsContext.Provider value={this.state}>
                {this.props.children}
            </SubmissionsContext.Provider>
        );
    }
}

export default SubmissionsProvider;
